// Global application state
export const API_BASE = '/api';
export const USER_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;

// State variables
export let currentCategory = 'world';
export let stories = [];
export let expandedStoryId = null;
export let blockingStory = null;
export let lastUpdated = null;
export let selectedBlockOption = null;
export let isSignedIn = false;
export let currentUser = null;
export let googleClientId = null;
export let pendingFeedback = null;
export let currentLayout = localStorage.getItem('layout') || 'list';
export let currentFontSize = localStorage.getItem('fontSize') || 'medium';
export let sessionExpandCount = 0;
export let nudgeDismissed = sessionStorage.getItem('nudgeDismissed') === 'true';
export let nudgeTimeoutId = null;
export let hasGivenFeedback = false;
export let currentTheme = localStorage.getItem('theme') || 'system';

// Category management
export const DEFAULT_CATEGORIES = ['world', 'tech', 'business', 'goodnews'];
export const ADDITIONAL_CATEGORIES = ['science', 'africa', 'startups', 'sports', 'europe', 'finance', 'latvia'];
export let userCategories = JSON.parse(localStorage.getItem('userCategories') || 'null') || [...DEFAULT_CATEGORIES];
export let allCategories = [];

// Category icons
export const categoryIcons = {
  tech: '💻', world: '🌍', business: '💼', science: '🔬',
  africa: '🦁', startups: '🚀', sports: '⚽', europe: '🇪🇺',
  finance: '📈', goodnews: '☀️', latvia: '🇱🇻'
};

// Reading history state
export let fullReadingHistory = [];
export let historyExpanded = false;

// State setters (needed because ES modules export bindings, not values)
export function setCurrentCategory(val) { currentCategory = val; }
export function setStories(val) { stories = val; }
export function setExpandedStoryId(val) { expandedStoryId = val; }
export function setBlockingStory(val) { blockingStory = val; }
export function setLastUpdated(val) { lastUpdated = val; }
export function setSelectedBlockOption(val) { selectedBlockOption = val; }
export function setIsSignedIn(val) { isSignedIn = val; }
export function setCurrentUser(val) { currentUser = val; }
export function setGoogleClientId(val) { googleClientId = val; }
export function setPendingFeedback(val) { pendingFeedback = val; }
export function setCurrentLayout(val) { currentLayout = val; localStorage.setItem('layout', val); }
export function setCurrentFontSize(val) { currentFontSize = val; localStorage.setItem('fontSize', val); }
export function setSessionExpandCount(val) { sessionExpandCount = val; }
export function setNudgeDismissed(val) { nudgeDismissed = val; sessionStorage.setItem('nudgeDismissed', String(val)); }
export function setNudgeTimeoutId(val) { nudgeTimeoutId = val; }
export function setHasGivenFeedback(val) { hasGivenFeedback = val; }
export function setCurrentTheme(val) { currentTheme = val; localStorage.setItem('theme', val); }
export function setUserCategories(val) { userCategories = val; localStorage.setItem('userCategories', JSON.stringify(val)); }
export function setAllCategories(val) { allCategories = val; }
export function setFullReadingHistory(val) { fullReadingHistory = val; }
export function setHistoryExpanded(val) { historyExpanded = val; }

// Getter functions for live bindings
export function getStories() { return stories; }
